import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { useForm, Controller, Feedback } from 'react-hook-form';
import Spinner from 'react-bootstrap/Spinner';

import { useHistory, NavLink, useLocation } from 'react-router-dom';
import logo from '../../asses/img/parkingl.png'
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import axios from 'axios';
import { FaHome } from 'react-icons/fa';
import { URL_EMPLOYEE } from '../../constans/servidor';


import BuscadorComponen from '../../components/Mensualidades/Buscador'
import TableComponentC from '../../components/Mensualidades/FiltradoC';
// import FormularComponen from '../../components/Mensualidades/Formulario';
import * as ROUTES from '../../constans/rutas';

const MensualidadesPage = () => {
  const [ventana, setVentana] = useState(1);
  const [Contrato, setContrato] = useState('');
  const [data, setData] = useState();
  const [opcionesContrato, setOpcionesContrato] = useState([]);
  const history = useHistory();

  const contratos = async () => {
    try {
      const res = await axios.get(`${URL_EMPLOYEE}/monthlyManagement/getContract`)
      console.log(res.data['data']);
      setContrato(
        res.data['data'].map((contratro) => ({
          value: contratro.id,
          label: contratro.nombreEmpresa,
        }))
      );

    } catch (error) {
    }
  }
  const ListContratos = async () => {
    try {
      const parametros={
        status:'1'
      }
      const res = await axios.post(`${URL_EMPLOYEE}/monthlyInstallment/list/lpr/listContract`,parametros)
      const respuesta=res.data['contractsFound']
      const datos= [...respuesta].sort((a, b) => a.idMonthlyContract - b.idMonthlyContract);

      setData(
        datos
      );

    } catch (error) {
    }
  }
  useEffect(() => {
    contratos()
    ListContratos()

  }, []);
  useEffect(() => {
    console.log('dataaaa');
    console.log(data);

  }, [Contrato,data]);


  return (

    <>
      <Container className="contendor-Principal">

        <Row>
          <Col className='cont_logo' xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className='logo' src={logo}></img>

            <p className="texto-slogan">Gestion  Mensualidades LPR</p>

          </Col>

        </Row>
        <Row className="justify-content-end ">
          <Col style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '15px' }} className='cont_logo' xs={12} sm={12} md={6} lg={4} xl={4}>

            <Button style={{ marginRight: '10px' }} variant="primary" onClick={() => history.push(ROUTES.HOME)}>
              <FaHome size={20} style={{ marginRight: '5px' }} />HOME
            </Button>
          </Col>

        </Row>
        <Row className="justify-content-end mbottom-20 menu">
          <Col className={ventana === 1 ? "menu_items2" : "menu_items"} xs={2} sm={2} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(1) }}>Contratos</button>
          </Col>
          <Col className={ventana === 2 ? "menu_items2" : "menu_items"} xs={4} sm={4} md={2} lg={2} xl={2}>
            <button onClick={() => { setVentana(2) }}>Placas</button>
          </Col>
        </Row>
      </Container>
      <Container>
        {ventana === 1? (
          <TableComponentC data={data} ></TableComponentC>
          // {Contrato}
        ) : null}
        {ventana === 2 ? (

          <BuscadorComponen Contrato={Contrato} info={data}></BuscadorComponen>
          // {Contrato}
        ) : null}

      </Container>

    </>
  )
}
export default MensualidadesPage;